/* 🤖 this file was generated by svg-to-ts */
export const iccIconDone: {
  name: 'done';
  data: string;
} = {
  name: 'done',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m8.8 15.9-4.2-4.2-1.4 1.4 5.6 5.6 12-12-1.4-1.4L8.8 15.9Z" fill="currentColor"/></svg>`
};
